import React from "react";
import attention from "../../../../content/blogs/GINE/attention.png";
import augmentation from "../../../../content/blogs/GINE/augmentation.png";
import result from "../../../../content/blogs/GINE/result.png";
import paper from "../../../../content/featured/GINE/GINE_SR.png";
export default {
  React,
  attention,
  augmentation,
  result,
  paper
};